// @flow

import { AddOutlined, ClearOutlined } from "@mui/icons-material";
import { FormControl, FormLabel, TextField, FormHelperText } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import { formControlDefaults, textFieldDefaults } from "../../../../helpers/theme/defaultProps";
import { ErrorMessage } from "formik";
import IconButton from '@mui/material/IconButton';

type Props = {};

const MultiTextField = (props: Props) => {
	const { value = [], onChange, onBlur, label, name, onAdd, onRemove, fieldMinWidth = '200px' } = props
	return (
		<Box>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					gap: 0.2,
					alignItems: 'center',
				}}
			>
				<FormLabel>{label}</FormLabel>
				<Button
					variant="text"
					sx={{
						padding: 0,
						minWidth: '30px',
						maxHeight: '30px',
						marginLeft: 0.1,
						marginRight: 0.1,
					}}
					onClick={onAdd}
				>
					<AddOutlined fontSize={'small'}/>
				</Button>
			</Box>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					gap: 1,
					alignItems: 'baseline',
					flexWrap: 'wrap',
				}}
			>
				{value.map((item, index) => {
					return (
						<FormControl key={item.id}>
							<TextField
								{...textFieldDefaults}
								name={`[${name}][${index}.value]`}
								value={value[index].value}
								onChange={(evt) => onChange(evt.target.value, item, index)}
								onBlur={onBlur}
								sx={{
									width: fieldMinWidth,
								}}
								slotProps={{
									input: {
										...(index > 0 ? {
											endAdornment: (
												<InputAdornment position={'end'}>
													<IconButton
														aria-label="toggle password visibility"
														onClick={() => onRemove(item, index)}
														edge="end"
													>
														<ClearOutlined/>
													</IconButton>
												</InputAdornment>
											),
										} : {})
									},
								}}
							/>
							<FormHelperText>
								<ErrorMessage name={`[${name}][${index}].value`}/>
							</FormHelperText>
						</FormControl>
					)
				})}
			</Box>
		</Box>
	)
};

export default MultiTextField